import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'square-dashed-x',
  size: 24,
  node: [
    ['path', { d: 'M14 21h1', key: 'v9vybs' }],
    ['path', { d: 'M14 3h1', key: '1ec4yj' }],
    ['path', { d: 'M19 3a2 2 0 012 2', key: '165vzh' }],
    ['path', { d: 'M21 14v1', key: '169vum' }],
    ['path', { d: 'M21 19a2 2 0 01-2 2', key: '9nkj6p' }],
    ['path', { d: 'M21 9v1', key: 'mxsmne' }],
    ['path', { d: 'M3 14v1', key: 'vnatye' }],
    ['path', { d: 'M3 9v1', key: '1r0deq' }],
    ['path', { d: 'M5 21a2 2 0 01-2-2', key: 'y6v07l' }],
    ['path', { d: 'M5 3a2 2 0 00-2 2', key: 'xbjhl9' }],
    ['path', { d: 'm9 15 6-6', key: '1ygkhp' }],
    ['path', { d: 'M9 21h1', key: '15o7lz' }],
    ['path', { d: 'M9 3h1', key: '1yesri' }],
    ['path', { d: 'm9 9 6 6', key: 'z0biqf' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name SquareDashedX
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQgMjFoMSIgLz4KICA8cGF0aCBkPSJNMTQgM2gxIiAvPgogIDxwYXRoIGQ9Ik0xOSAzYTIgMiAwIDAxMiAyIiAvPgogIDxwYXRoIGQ9Ik0yMSAxNHYxIiAvPgogIDxwYXRoIGQ9Ik0yMSAxOWEyIDIgMCAwMS0yIDIiIC8+CiAgPHBhdGggZD0iTTIxIDl2MSIgLz4KICA8cGF0aCBkPSJNMyAxNHYxIiAvPgogIDxwYXRoIGQ9Ik0zIDl2MSIgLz4KICA8cGF0aCBkPSJNNSAyMWEyIDIgMCAwMS0yLTIiIC8+CiAgPHBhdGggZD0iTTUgM2EyIDIgMCAwMC0yIDIiIC8+CiAgPHBhdGggZD0ibTkgMTUgNi02IiAvPgogIDxwYXRoIGQ9Ik05IDIxaDEiIC8+CiAgPHBhdGggZD0iTTkgM2gxIiAvPgogIDxwYXRoIGQ9Im05IDkgNiA2IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/square-dashed-x
 * @see https://lucide.dev/guide/packages/lucide-preact - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SquareDashedX = createLucideIcon(__iconData);

export default SquareDashedX;
